import React, { useState, useEffect } from 'react';
import { makeStyles, Grid, TextField, Button, Snackbar, Divider, List, ListItem, ListItemText } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import Strapi from '../../services/strapi';
import StrapiMedia from '../../atoms/StrapiMedia';
import TinyMCE from '../../atoms/TinyMCE';
import ArticleEditorProps from '../../interfaces/ArticleEditorProps';
import ArticleField from '../../atoms/ArticleField';
import { useNotification } from '../../contexts/Notification';
import { useHistory } from 'react-router-dom';
import settings from '../../settings';

const useStyles = makeStyles({
	container: {
		display: 'inline',
	},
	link: {
		color: "inherit",
		textDecoration: "none"
	}
});

const AuthorEditor = (props: ArticleEditorProps) => {
	const { slug } = useParams<{ slug: string }>();
	const [id, setId] = useState<number>(-1);
	const [firstname, setFirstname] = useState<string>("");
	const [lastname, setLastname] = useState<string>("");
	//type
	const [fonction, setFonction] = useState<string>("");
	const [shortbiography, setShortbiography] = useState<string>("");
	const [longbiography, setLongbiography] = useState<string>("");
	const [website, setWebsite] = useState<string>("");
	const [facebook, setFacebook] = useState<string>("");
	const [twitter, setTwitter] = useState<string>("");
	const [linkedin, setLinkedin] = useState<string>("");
	const [image, setImage] = useState<any[]>([]);
	const notification = useNotification();
	const [alreadyExist, setAlreadyExist] = useState<any[]>([]);
	const history = useHistory();

	const updateAlreadyExist = (new_firstname: string, new_lastname: string) => {
		Strapi.get(`/authors?lastname=${new_lastname}&firstname=${new_firstname}`).then(r => {
			setAlreadyExist(r);
		})
	}

	const update = () => {
		const article = {
			id,
			firstname,
			lastname,
			fonction,
			shortbiography,
			longbiography,
			website,
			facebook,
			twitter,
			linkedin,
			image,
		};
		const url = props.type === "edit" ? "authors/" + article.id + "/revision" : "authors";
		return Strapi.post(url, {}, article);
	}

	const classes = useStyles();

	useEffect(() => {
		if (props.type === "edit" && slug) {
			Strapi.get(`/authors/${slug}`).then((r) => {
				setId(r.id);
				setFirstname(r.firstname);
				setLastname(r.lastname);
				setFonction(r.fonction);
				setShortbiography(r.shortbiography);
				setLongbiography(r.longbiography);
				setImage(r.image);
				setWebsite(r.website);
				setFacebook(r.facebook);
				setTwitter(r.twitter);
				setLinkedin(r.linkedin);
			});
		}
	}, [props.type, slug]);

	return (
		<div>
			<Grid container direction="column" spacing={4}>
				<Snackbar
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}
						open={true}
					>
					{props.type === "edit" ? 
						<Button variant="contained" color="primary" onClick={() => {
							notification.notify("updating...", "info");
							update().then(r => {
								notification.notify("author updated");	
								history.push("/authors");
							}).catch(e => {
								notification.notify("fail to update author", "error");	
							});
						}}>Update</Button>
						: <Button variant="contained" disabled={firstname === "" || lastname === ""} color="primary" onClick={() => {
							notification.notify("creating...", "info");
							update().then(r => {
								notification.notify("author created");	
								history.push("/authors");
							}).catch(e => {
								notification.notify("fail to create author", "error");	
							});
						}}>Create</Button>}
				</Snackbar>
				<Grid container item spacing={4}>
					<Grid item sm={6} container spacing={4}>
						<ArticleField>
							<TextField fullWidth={true} required label="Prénom" value={firstname} onChange={(e) => {
								setFirstname(e.target.value);
								updateAlreadyExist(e.target.value, lastname);
							}} />
						</ArticleField>
						<ArticleField>
							<TextField fullWidth={true} required label="Nom" value={lastname} onChange={(e) => {
								setLastname(e.target.value);
								updateAlreadyExist(firstname, e.target.value);
							}} />
						</ArticleField>
					</Grid>
					<Grid item sm={6}>
						<div className={classes.container}>

							{alreadyExist.length !== 0 && <>
								Auteur{alreadyExist.length > 1 && "s"} ayant le meme nom:
								<List>
									{alreadyExist.map(e => <ListItem alignItems="flex-start">
										<a className={classes.link}
											key={e.id} href={`${settings.frontUrl}author/${e.slug}`} target="_blank" rel="noopener noreferrer">
											<ListItemText>{e.firstname} {e.lastname}</ListItemText>
											<ListItemText>
												<div dangerouslySetInnerHTML={{
													__html: e.shortbiagarphy ?? e.longbiography
												}}/>
											</ListItemText>
										</a>
										<Divider/>
									</ListItem>)}
								</List>
							</>}
						</div>
					</Grid>
				</Grid>
				<ArticleField>
					<TextField fullWidth={true} label="Fonction" value={fonction} onChange={(e) => {
						setFonction(e.target.value);
					}} />
				</ArticleField>
				<ArticleField label="Biographie courte">
					<TinyMCE
						height={200}
						value={shortbiography}
						onEditorChange={setShortbiography}
					/>
				</ArticleField>
				<ArticleField label="Biographie longue">
					<TinyMCE
						height={200}
						value={longbiography}
						onEditorChange={setLongbiography}
					/>
				</ArticleField>
				<ArticleField label="Image">
					<StrapiMedia multiple type="image" value={image} onChange={setImage} />
				</ArticleField>
				<ArticleField label="Site internet">
					<TextField fullWidth={true} required value={website} onChange={(e) => {
						setWebsite(e.target.value);
					}} />
				</ArticleField>
				<ArticleField label="Facebook" >
					<TextField fullWidth={true} required value={facebook} onChange={(e) => {
						setFacebook(e.target.value);
					}} />
				</ArticleField>
				<ArticleField label="Twitter">
					<TextField fullWidth={true} required value={twitter} onChange={(e) => {
						setTwitter(e.target.value);
					}} />
				</ArticleField>
				<ArticleField label="Linkedin">
					<TextField fullWidth={true} required value={linkedin} onChange={(e) => {
						setLinkedin(e.target.value);
					}} />
				</ArticleField>
			</Grid>
		</div>
	);
}

export default AuthorEditor;